package br.com.htms.inspeccaocampo.ui.screens

import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowForward
import androidx.compose.material.icons.filled.Build
import androidx.compose.material.icons.filled.ShoppingCart
import androidx.compose.material.icons.filled.DateRange
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.List
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Star
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.Icon
import androidx.compose.ui.graphics.vector.ImageVector
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.FormTipo
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.form.HubSecao
import br.com.htms.inspeccaocampo.shared.ui.components.ManualDialog

@Composable
fun SharedFormHubScreen(controller: AppController) {
    val authUser by controller.authUser.collectAsState()
    val appConfig by controller.appConfig.collectAsState()
    val pendentes by controller.pendentesCount.collectAsState()
    val historico by controller.historico.collectAsState()
    val hubForms = FormTipo.hubEntries.map { tipo ->
        tipo to when (tipo) {
            FormTipo.INSPECAO_CAMPO ->
                "Checklist diário de campo com fotos, GPS e assinaturas (fluxo atual)."
            FormTipo.CHECKLIST_DIARIO_HTMS ->
                "Inspeção HTMS — tipos de equipamento/veículo (C/NC/NA), igual ao Checklist Diário."
            FormTipo.CHECKLIST_DIARIO_AXIA ->
                "Inspeção Axia — mobilização e tipos de equipamento/veículo (C/NC/NA)."
            FormTipo.RELATORIO_ALOJAMENTO -> "realizar parte 1 e 2"
            FormTipo.CHECKLIST_VETORES ->
                "Inspeção semanal de vetores e pragas no alojamento. Conforme e não conforme pedem foto; N/A pede justificativa."
            FormTipo.COMUNICACAO_OCORRENCIAS -> "Acidente, incidentes e quase acidentes"
            FormTipo.REM_SEGURANCA_OBRAS ->
                "Indicadores mensais de segurança por obra (HTMS e Subcontratados) com Excel oficial."
            FormTipo.RELATORIO_SEGURANCA ->
                "Relatório mensal PPTX por obra (Dados gerais, Gestão de SMS, DDS, Treinamentos)."
            FormTipo.ANALISE_VISUAL_NR ->
                "Tire fotos da cena — a IA identifica o objeto e a NR. Assistente — nao e laudo; so achados confirmados no relatorio."
            FormTipo.EVIDENCIA_TREINAMENTO ->
                "Registro do curso ministrado: obra, TST, carga horária, fotos e lista de presença. As horas entram no REM do mês."
            else -> tipo.rotulo
        }
    }.filter { (tipo, _) ->
        authUser?.canAccessForm(tipo, appConfig) != false
    }
    val secaoEscolhida by controller.hubSecao.collectAsState()
    val podeDocumentos = authUser?.podeEmitirDocumentos(appConfig) == true
    val podeAtivos = authUser?.podeAcessarAtivos(appConfig) == true
    val podeColab = authUser?.podeAcessarColaboradores == true
    val podeEfetivo = authUser?.podeAcessarEfetivo == true
    val podeOcorrencias = authUser?.podeAcessarOcorrencias == true
    val podeEstoque = authUser?.podeAcessarEstoque == true
    val podeDashboards = authUser?.podeAcessarDashboards == true
    val areas = listOf(
        hubForms.isNotEmpty(),
        podeColab || podeDocumentos,
        podeAtivos,
        podeEfetivo,
        podeOcorrencias,
        podeEstoque,
        podeDashboards
    ).count { it }
    val temMenuRaiz = areas >= 2
    val secao = when {
        temMenuRaiz -> when {
            secaoEscolhida == HubSecao.DOCUMENTOS && !(podeDocumentos || podeColab) -> HubSecao.RAIZ
            secaoEscolhida == HubSecao.FORMULARIOS && hubForms.isEmpty() -> HubSecao.RAIZ
            else -> secaoEscolhida
        }
        podeAtivos || podeColab || podeDocumentos || podeEfetivo || podeOcorrencias || podeEstoque || podeDashboards -> HubSecao.RAIZ
        hubForms.isEmpty() && (podeDocumentos || podeColab) -> HubSecao.DOCUMENTOS
        else -> HubSecao.FORMULARIOS
    }
    // Documentos foi unificado em Colaboradores QSMS.
    LaunchedEffect(secao) {
        if (secao == HubSecao.DOCUMENTOS && (podeDocumentos || podeColab)) {
            controller.abrirColaboradores()
        }
    }
    var mostrarManual by remember { mutableStateOf(false) }
    if (mostrarManual) ManualDialog(onDismiss = { mostrarManual = false })

    val rolagem106 = androidx.compose.foundation.lazy.rememberLazyListState()
    br.com.htms.inspeccaocampo.ui.kit.AreaRolavel(rolagem106, Modifier.fillMaxSize().background(PortalCores.FundoPainel)) {
    LazyColumn(
        state = rolagem106,
        modifier = Modifier.fillMaxSize(),
        contentPadding = PaddingValues(horizontal = 20.dp, vertical = 22.dp),
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        item {
            if (secao != HubSecao.RAIZ && temMenuRaiz) {
                TextButton(
                    onClick = { controller.abrirHubSecao(HubSecao.RAIZ) },
                    contentPadding = PaddingValues(0.dp)
                ) { Text("← Menu principal") }
            }
            Text(
                when (secao) {
                    HubSecao.RAIZ -> "Menu principal"
                    HubSecao.FORMULARIOS -> "Checklists / Formulários"
                    HubSecao.DOCUMENTOS -> "Emissão de Documentos"
                },
                style = MaterialTheme.typography.headlineSmall,
                fontWeight = FontWeight.Bold,
                color = PortalCores.Navy
            )
            Text(
                when (secao) {
                    HubSecao.RAIZ -> "Escolha a área que deseja acessar."
                    HubSecao.FORMULARIOS ->
                        "Escolha o tipo de inspeção/relatório. Em qualquer formulário use Voltar (topo) ou Menu (barra inferior) para voltar aqui e trocar de checklist."
                    HubSecao.DOCUMENTOS ->
                        "Documentos emitidos a partir do cadastro de funcionários. Novos tipos de documento serão adicionados aqui."
                },
                style = MaterialTheme.typography.bodyMedium,
                color = PortalCores.CinzaTexto,
                modifier = Modifier.padding(top = 4.dp, bottom = 8.dp)
            )
            if (pendentes > 0 && secao != HubSecao.DOCUMENTOS) {
                val sincronizando = historico.sincronizandoPendentes
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(
                            Color(0xFFFFF3CD),
                            RoundedCornerShape(8.dp)
                        )
                        .padding(12.dp),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(10.dp)
                ) {
                    Column(modifier = Modifier.weight(1f)) {
                        Text(
                            "⚠ $pendentes formulário(s) pendente(s)",
                            style = MaterialTheme.typography.titleSmall,
                            fontWeight = FontWeight.Bold,
                            color = Color(0xFF856404)
                        )
                        Text(
                            "Envio não concluído. Toque para sincronizar.",
                            style = MaterialTheme.typography.bodySmall,
                            color = Color(0xFF856404)
                        )
                    }
                    if (sincronizando) {
                        CircularProgressIndicator(
                            modifier = Modifier.size(28.dp),
                            strokeWidth = 3.dp,
                            color = Color(0xFF856404)
                        )
                    } else {
                        PortalButton(
                            onClick = { controller.sincronizarPendentes() },
                            colors = ButtonDefaults.buttonColors(
                                containerColor = Color(0xFF856404),
                                contentColor = Color.White
                            )
                        ) {
                            Text("Sincronizar")
                        }
                    }
                }
            }
        }
        when (secao) {
            HubSecao.RAIZ -> {
                if (podeDashboards) {
                    item {
                        HubCard(
                            titulo = "Dashboards",
                            descricao = "Indicadores e gráficos de todos os módulos liberados para você, com filtros e modo apresentação.",
                            icone = Icons.Filled.Star,
                            onClick = { controller.abrirDashboards() }
                        )
                    }
                }
                if (hubForms.isNotEmpty()) {
                    item {
                        HubCard(
                            titulo = "Checklists / Formulários",
                            descricao = "Inspeções, checklists e relatórios de campo (TST e ADM) — ${hubForms.size} disponível(is).",
                            icone = Icons.Filled.List,
                            onClick = { controller.abrirHubSecao(HubSecao.FORMULARIOS) }
                        )
                    }
                }
                if (podeAtivos) {
                    item {
                        HubCard(
                            titulo = "Controle de Ativos",
                            descricao = "Equipamentos e ferramentas por centro de custo: cadastro, fornecedores, custos e movimentações em tempo real.",
                            icone = Icons.Filled.Build,
                            onClick = { controller.abrirAtivos() }
                        )
                    }
                }
                if (podeColab || podeDocumentos) {
                    item {
                        HubCard(
                            titulo = "Colaboradores — QSMS",
                            descricao = "Matriz (ASO, NRs, CNH, vencimentos) e emissão de documentos (Funcionários, OS, EPI, Certificados, APR).",
                            icone = Icons.Filled.Person,
                            onClick = { controller.abrirColaboradores() }
                        )
                    }
                }
                if (podeEfetivo) {
                    item {
                        HubCard(
                            titulo = "Controle de Efetivo",
                            descricao = "Alocação por obra, transferências com aprovação, lançamentos de folga, férias e afastamentos, e controle de folgas de campo.",
                            icone = Icons.Filled.DateRange,
                            onClick = { controller.abrirEfetivo() }
                        )
                    }
                }
                if (podeEstoque) {
                    item {
                        HubCard(
                            titulo = "Estoque",
                            descricao = "Saldo por centro de custo, entradas, saídas e transferências, com o cadastro de colaboradores e as máquinas e ferramentas das obras.",
                            icone = Icons.Filled.ShoppingCart,
                            onClick = { controller.abrirEstoque() }
                        )
                    }
                }
                if (podeOcorrencias) {
                    item {
                        HubCard(
                            titulo = "Gestão de Ocorrências",
                            descricao = "Incidentes, acidentes (inclusive de trajeto) e danos materiais com ID automático, investigação, fotos e planos de ação.",
                            icone = Icons.Filled.Warning,
                            onClick = { controller.abrirOcorrencias() }
                        )
                    }
                }
            }
            HubSecao.FORMULARIOS -> {
                item {
                    Row(
                        Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        PortalOutlinedButton(
                            onClick = {
                                controller.registrarManualAberto(FormTipo.INSPECAO_CAMPO)
                                mostrarManual = true
                            },
                            modifier = Modifier.weight(1f)
                        ) { Text("Ver manual") }
                        PortalOutlinedButton(
                            onClick = { controller.openNrVigente() },
                            modifier = Modifier.weight(1f)
                        ) { Text("NR Vigente") }
                    }
                }
                if (hubForms.isEmpty()) {
                    item {
                        Text(
                            "Nenhum formulário disponível para o seu tipo de perfil. Peça ao admin para ajustar TST/ADM.",
                            style = MaterialTheme.typography.bodyMedium
                        )
                    }
                }
                hubForms.forEach { (tipo, descricao) ->
                    item {
                        HubCard(
                            titulo = tipo.rotulo,
                            descricao = descricao,
                            onClick = { controller.abrirFormulario(tipo) }
                        )
                    }
                }
            }
            HubSecao.DOCUMENTOS -> {
                                item {
                    HubCard(
                        titulo = "Funcionários e documentos",
                        descricao = "Cadastro, dashboard e importação. No menu lateral do módulo: OS, Ficha de EPI, Certificados e APR.",
                        onClick = { controller.abrirFuncionarios() }
                    )
                }
item {
                    HubCard(
                        titulo = "Ordem de Serviço (NR-01) — teste",
                        descricao = "Selecione o funcionário cadastrado ou informe nome, CPF, admissão e cargo: riscos e descrição vêm do PGR e a OS sai em PDF, já salva no cadastro.",
                        onClick = { controller.abrirOrdemServico() }
                    )
                }
                item {
                    HubCard(
                        titulo = "Ficha de EPI",
                        descricao = "Ficha de controle e entrega de EPI em uma página: EPIs da Matriz por função com o CA de cada item, mesma data de entrega para todos e salva no cadastro do funcionário.",
                        onClick = { controller.abrirFichaEpi() }
                    )
                }
                item {
                    HubCard(
                        titulo = "Certificados (NR 06, NR 10, NR 18, NR 33, NR 35)",
                        descricao = "Certificado no modelo oficial com o nome e CPF do funcionário cadastrado, período do curso e data de emissão; assinaturas do engenheiro/instrutor mantidas. Salvo no cadastro.",
                        onClick = { controller.abrirCertificados() }
                    )
                }
                item {
                    HubCard(
                        titulo = "APR - Análise Preliminar de Riscos",
                        descricao = "APR no modelo HTMS: responsáveis, assinantes e executantes do cadastro de funcionários, EPIs/EPCs da Matriz e etapas da tarefa. Emite em PDF (horizontal) ou Excel.",
                        onClick = { controller.abrirApr() }
                    )
                }

            }
        }
    }
    }
}

@Composable
private fun HubCard(titulo: String, descricao: String, icone: ImageVector = Icons.Filled.ArrowForward, onClick: () -> Unit) {
    Card(
        onClick = onClick,
        modifier = Modifier.fillMaxWidth().border(1.dp, PortalCores.Borda, RoundedCornerShape(14.dp)),
        shape = RoundedCornerShape(14.dp),
        colors = CardDefaults.cardColors(containerColor = PortalCores.Cartao),
        elevation = CardDefaults.cardElevation(defaultElevation = 0.dp)
    ) {
        Row(Modifier.padding(horizontal = 20.dp, vertical = 18.dp), verticalAlignment = Alignment.CenterVertically) {
            Box(
                Modifier.size(44.dp).background(PortalCores.AzulClaro, RoundedCornerShape(12.dp)),
                contentAlignment = Alignment.Center
            ) {
                Icon(icone, contentDescription = null, tint = PortalCores.AzulIcone, modifier = Modifier.size(24.dp))
            }
            Spacer(Modifier.width(16.dp))
            Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                Text(titulo, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge, color = PortalCores.Navy)
                Text(descricao, style = MaterialTheme.typography.bodyMedium, color = PortalCores.CinzaTexto)
            }
            Spacer(Modifier.width(12.dp))
            Text("Abrir", fontWeight = FontWeight.SemiBold, color = PortalCores.Navy)
        }
    }
}
